import React, { useState, useEffect } from "react";
import { post } from "../services/http-service";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Box from "@mui/material/Box";
import FormGroup from "@mui/material/FormGroup";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import PropTypes from "prop-types";
import Alert from "@mui/material/Alert";

const FIELDS = [
  { key: "email", label: "E-postadress", required: true, value: "" },
  { key: "firstname", label: "Förnamn", required: true, value: "" },
  { key: "lastname", label: "Efternamn", required: true, value: "" },
  { key: "company", label: "Företag/Organisation", required: true, value: "" },
  { key: "department", label: "Avdelning", value: "" },
];

function RequestLoginDialog({ open, onClose }) {
  const [errorMessage, setErrorMessage] = useState("");

  const [fields, setFields] = useState(FIELDS);

  useEffect(() => {
    setErrorMessage("");
  }, [open]);

  const changeField = (index, value) => {
    const newFields = [...fields];

    newFields[index].value = value;

    setFields(newFields);
  };

  const onSubmit = async () => {
    for (let i = 0; i < fields.length; i++) {
      if (fields[i].required && !fields[i].value) {
        return setErrorMessage(`${FIELDS[i].label} är obligatoriskt`);
      }
    }

    const form = new FormData();

    fields.forEach((f) => {
      form.append(f.key, f.value);
    });

    await post("/login/requestIndividual", form, true);

    setErrorMessage("");

    onClose();
  };

  return (
    <Dialog
      open={open}
      scroll="paper"
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
    >
      <DialogTitle id="scroll-dialog-title">
        Beställ personlig inloggning
      </DialogTitle>

      <Box width={600}>
        <DialogContent dividers>
          {errorMessage && (
            <Box mb={4}>
              <Alert variant="filled" severity="error">
                {errorMessage}
              </Alert>
            </Box>
          )}

          <FormGroup>
            {fields.map((field, index) => (
              <Box key={index}>
                <TextField
                  onChange={(e) => changeField(index, e.target.value)}
                  value={field.value}
                  margin="normal"
                  required={field.required}
                  fullWidth
                  label={field.label}
                />
              </Box>
            ))}
          </FormGroup>
        </DialogContent>
      </Box>

      <DialogActions>
        <Button variant="contained" onClick={onSubmit}>
          Skicka
        </Button>

        <Button onClick={onClose}>Avbryt</Button>
      </DialogActions>
    </Dialog>
  );
}

RequestLoginDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
};

export default RequestLoginDialog;
